import React, { useState } from 'react';
import TrailerIcon from '@mui/icons-material/LocalShipping';

import { MenuAnchor } from '@paragon/client-tools';
import { Trailer } from '@paragon/contract-library';
import { hasSupervisorFeatureFlag } from '@paragon/login-tools';

import { useAppSelector } from '../../hooks';
import { TrailerMenu } from '../menus/TrailerMenu';
import { BaseCard } from './BaseCard';

export function TrailerCard(props: { trailer: Trailer }) {
  const isSupervisor = useAppSelector(hasSupervisorFeatureFlag);
  const [menuAnchor, setMenuAnchor] = useState<MenuAnchor>(null);

  return (
    <BaseCard
      title={props.trailer.name}
      subheader={props.trailer.archived ? 'Archived' : null}
      avatar={<TrailerIcon />}
      menu={
        isSupervisor ? (
          <TrailerMenu trailer={props.trailer} anchor={menuAnchor} onClose={() => setMenuAnchor(null)} />
        ) : undefined
      }
      onSetMenuAnchor={setMenuAnchor}
    />
  );
}
